// 全局主题和语言配置
export default {
  colorTheme: {
    dark: false,
    themes: {
      light: {
        primary: '#388E3C',
        secondary: '#FFD600',
        accent: '#F57F17'
      }
    }
  },
  lang: {
    supported: {
      zh: '中文',
      en: 'English'
    },
    fallback: 'zh'
  },
  logo: './static/icon/logo.png',
  logoWidth: '120',
  logoHeight: '40',
  showCopyrightYear: true
}
